import { render } from "./TemplateView.vue?vue&type=template&id=4d5e0129"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"

import "./TemplateView.vue?vue&type=style&index=0&id=4d5e0129&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/TemplateView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d5e0129"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d5e0129', __exports__)) {
    api.reload('4d5e0129', __exports__)
  }
  
  module.hot.accept("./TemplateView.vue?vue&type=template&id=4d5e0129", () => {
    api.rerender('4d5e0129', render)
  })

}


export default __exports__